import { useTranslation } from 'react-i18next';
import { useNavigate, useParams } from 'react-router-dom';
import { Box } from '@mui/material';
import { useTheme } from '@mui/material/styles';
import PageTitle from '../../../components/Text/PageTitle';
import usePortalConfig from '../../../hooks/usePortalConfig/usePortalConfig';
import useRolePermissions from '../../../hooks/useRolePermissions/useRolePermissions';
import CompanyOnboardingForm from './components/CompanyOnboardingForm';
import Breadcrumbs from '../../../components/Breadcrumbs/Breadcrumbs';
import ArrowLeft from '../../../components/Icons/ArrowLeft';
import useCompanyOnboarding from './useCompanyOnboarding';

function CompanyOnboarding() {
  const [t] = useTranslation();
  const { id } = useParams();
  const { companyData } = useCompanyOnboarding();
  const theme = useTheme();
  const navigate = useNavigate();
  const { isUserAllowed } = useRolePermissions();
  const { routePermissions } = usePortalConfig();
  const editMode = isUserAllowed(routePermissions.companiesEdit);

  /**
   * Handle the close action
   */
  const handleClose = () => {
    navigate('/companies');
  };

  return (
    <>
      <Breadcrumbs
        activeLinks={[{ label: t('navbar.companyOnboarding'), url: '/companies' }]}
        disabledLinks={[id ? companyData.name : t('translation:pages.companyOnboarding.title')]}
      />

      <Box sx={{ display: 'flex', alignItems: 'center', paddingBottom: '2.75rem' }}>
        <ArrowLeft
          stroke={theme.palette.primary.main}
          style={{ cursor: 'pointer', marginRight: '1rem' }}
          onClick={handleClose}
        />
        {id ? (
          <div>
            {editMode ? (
              <PageTitle>{t('translation:pages.companyOnboarding.titleEdit')}</PageTitle>
            ) : (
              <PageTitle>{t('translation:pages.companyOnboarding.titleView')}</PageTitle>
            )}
          </div>
        ) : (
          <PageTitle>{t('pages.companyOnboarding.title')}</PageTitle>
        )}
      </Box>
      <CompanyOnboardingForm editMode={editMode} />
    </>
  );
}

export default CompanyOnboarding;
